/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MoveTicketRequestDto
 */
export interface MoveTicketRequestDto {
    /**
     * Required unless createNewWorkOrder is true
     * @type {string}
     * @memberof MoveTicketRequestDto
     */
    targetWorkOrderId?: string;
    /**
     * When true, create a new Planned WO for the ticket site and move the ticket there
     * @type {boolean}
     * @memberof MoveTicketRequestDto
     */
    createNewWorkOrder?: boolean;
    /**
     * 
     * @type {object}
     * @memberof MoveTicketRequestDto
     */
    reason?: object | null;
}

/**
 * Check if a given object implements the MoveTicketRequestDto interface.
 */
export function instanceOfMoveTicketRequestDto(value: object): value is MoveTicketRequestDto {
    return true;
}

export function MoveTicketRequestDtoFromJSON(json: any): MoveTicketRequestDto {
    return MoveTicketRequestDtoFromJSONTyped(json, false);
}

export function MoveTicketRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoveTicketRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'targetWorkOrderId': json['targetWorkOrderId'] == null ? undefined : json['targetWorkOrderId'],
        'createNewWorkOrder': json['createNewWorkOrder'] == null ? undefined : json['createNewWorkOrder'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function MoveTicketRequestDtoToJSON(json: any): MoveTicketRequestDto {
    return MoveTicketRequestDtoToJSONTyped(json, false);
}

export function MoveTicketRequestDtoToJSONTyped(value?: MoveTicketRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'targetWorkOrderId': value['targetWorkOrderId'],
        'createNewWorkOrder': value['createNewWorkOrder'],
        'reason': value['reason'],
    };
}

